module.exports = __webpack_public_path__ + "static/logo-variant4-ee24a136fdd60d63151e1f1d0e4b2d01.png";